import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AllUsers from "../pages/dashboardPage/userSettings/allUsers/AllUsers";
import UserImages from "../pages/dashboardPage/userSettings/userImages/UserImages";

// Tab id (permissionCatalog "users") → its page.
const TAB_PAGES = {
  "all-users": AllUsers,
  "user-images": UserImages,
};

const UserNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("users", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {rolePermissions.includes("view-users") && (
        // Search now lives on the players list; keep old links working.
        <Route
          path="/search-one-user"
          element={<Navigate to="/dashboard/users/show-all-users" replace />}
        />
      )}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default UserNavigator;
